import { useSearchParams, Link } from 'react-router-dom';

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const status = params.get('status');
  const ok = status === 'ok';

  return (
    <div className="auth-layout">
      <div className="auth-card" style={{ textAlign: 'center' }}>
        <div className="auth-brand">
          <img src="/logo.png" alt="Autonation" className="auth-logo auth-logo-xl" onError={e => { e.target.style.display = 'none'; }} />
        </div>
        {ok ? (
          <>
            <div style={{ fontSize: '3rem', margin: '1rem 0' }}>✅</div>
            <h2 style={{ color: '#4ade80', margin: '0 0 0.5rem' }}>Email verificado</h2>
            <p style={{ color: 'var(--silver-light,#cbd5e1)' }}>
              Tu email ha sido confirmado exitosamente.
            </p>
          </>
        ) : (
          <>
            <div style={{ fontSize: '3rem', margin: '1rem 0' }}>❌</div>
            <h2 style={{ color: '#f87171', margin: '0 0 0.5rem' }}>Enlace inválido</h2>
            <p style={{ color: 'var(--silver-light,#cbd5e1)' }}>
              El enlace de verificación expiró o no es válido.
            </p>
          </>
        )}
        <Link to="/login" className="btn btn-primary" style={{ marginTop: '1.5rem', display: 'inline-block' }}>
          Ir al inicio
        </Link>
      </div>
    </div>
  );
}
